import { useSelector } from "react-redux";
import { makeSelectUserInfo } from "@containers/App/selectors";
import { User } from "../interfaces/user";

const useUser = (): User => useSelector(makeSelectUserInfo());

export default useUser;
